import { render } from "./aboutMe.vue?vue&type=template&id=4e28a387&scoped=true"
import script from "./aboutMe.vue?vue&type=script&lang=js"
export * from "./aboutMe.vue?vue&type=script&lang=js"

import "./aboutMe.vue?vue&type=style&index=0&id=4e28a387&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e28a387"]])

export default __exports__